import { NewUpdatedEventNote } from './event-note.types';
import { Injectable } from '@angular/core';
import { AzcMoment } from '../../common/datetime/azc-moment.const';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EventNoteService {
	private notesUrl = (eventId: number) => `api/events/${eventId}/notes`;
	private noteUrl = (eventId: number, noteId: number) => `api/events/${eventId}/notes/${noteId}`;

	constructor(private http: HttpClient) { }

	addNote(eventId: number, newNote: NewUpdatedEventNote): Promise<number> {
		return this.http.post<number>(this.notesUrl(eventId), newNote).toPromise();
	}

	updateNote(eventId: number, noteId: number, updatedNote: NewUpdatedEventNote): Promise<void> {
		updatedNote.actionOn = AzcMoment.format(updatedNote.actionOn);

		return this.http.put<void>(this.noteUrl(eventId, noteId), updatedNote).toPromise();
	}

	actionedNote(eventId: number, noteId: number): Promise<any> {
		return this.http.put<void>(this.noteUrl(eventId, noteId), {}).toPromise();
	}

	deleteNote(eventId: number, noteId: number): Promise<any> {
		return this.http.delete<void>(this.noteUrl(eventId, noteId)).toPromise();
	}
}
